import React from 'react';
import { Box } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { RelatedOfferDetails } from 'components/shop/MobilePlans/typings/plans';
import MinimalPlanCard from '../MinimalPlanCard';

interface BaseSelectQuantityStepProps {
  plan: RelatedOfferDetails;
  regionId: string;
  heading: React.ReactNode;
  quantitySelector: React.ReactNode;
}

const BaseSelectQuantityStep = ({
  plan,
  regionId,
  heading,
  quantitySelector,
}: BaseSelectQuantityStepProps) => {
  return (
    <LinkRegion regionId={regionId}>
      {heading}
      <Box mb="s5">
        <MinimalPlanCard plan={plan} />
      </Box>
      {quantitySelector}
    </LinkRegion>
  );
};

export default BaseSelectQuantityStep;
